// @generated by errorreasonsgen from api/manifests/error-reasons.yaml — DO NOT EDIT.
// Regenerate: bazel run //build/sync:sync

import type { AllMessageKeys } from './messages_gen';

/** The server error reasons the web-public app localizes (`surface: [public]`). */
export type PublicServerErrorReason =
  | "account.v1.feedback_empty_message"
  | "account.v1.lead_already_exists"
  | "account.v1.lead_invalid_input"
  | "account.v1.lead_listing_not_live"
  | "account.v1.lead_not_found"
  | "account.v1.lead_self_inquiry"
  | "account.v1.listing_already_exists"
  | "account.v1.listing_building_not_found"
  | "account.v1.listing_cannot_publish_non_in_prog"
  | "account.v1.listing_cannot_relist_incomplete"
  | "account.v1.listing_cannot_relist_non_unlisted"
  | "account.v1.listing_cannot_unlist_non_listed"
  | "account.v1.listing_image_id_required"
  | "account.v1.listing_image_not_found"
  | "account.v1.listing_invalid_input"
  | "account.v1.listing_not_found"
  | "account.v1.listing_not_owner"
  | "account.v1.listing_wizard_incomplete"
  | "account.v1.saved_already_exists"
  | "account.v1.saved_invalid_input"
  | "account.v1.saved_invalid_saveable_id"
  | "account.v1.saved_not_found"
  | "account.v1.support_invalid_input"
  | "account.v1.support_not_found"
  | "auth.v1.already_linked"
  | "auth.v1.check_failed"
  | "auth.v1.code_required"
  | "auth.v1.email_in_use"
  | "auth.v1.email_not_verified"
  | "auth.v1.google_sign_in_failed"
  | "auth.v1.invalid_code"
  | "auth.v1.invalid_input"
  | "auth.v1.invalid_phone"
  | "auth.v1.invalid_token"
  | "auth.v1.last_provider"
  | "auth.v1.link_failed"
  | "auth.v1.not_linked"
  | "auth.v1.phone_in_use"
  | "auth.v1.phone_number_required"
  | "auth.v1.rate_limited"
  | "auth.v1.send_failed"
  | "auth.v1.unlink_failed"
  | "conversations.v1.content_empty"
  | "conversations.v1.conversation_id_required"
  | "conversations.v1.invalid_input"
  | "conversations.v1.message_blocked_external_contact"
  | "conversations.v1.not_participant"
  | "conversations.v1.unknown_read_cursor"
  | "payments.v1.checkout_disabled"
  | "payments.v1.listing_already_paid"
  | "storefront.v1.category_not_found"
  | "storefront.v1.district_not_found"
  | "storefront.v1.estate_not_found"
  | "storefront.v1.listing_not_found"
  | "storefront.v1.partner_not_found"
  | "storefront.v1.post_not_found";

/** Reason -> ui-strings catalog key, typed against the app catalog. The app
 * error-localize seam resolves this then renders `formatMessage({ id: key }, metadata)`. */
export const REASON_MESSAGE_KEY: Record<PublicServerErrorReason, AllMessageKeys> = {
  "account.v1.feedback_empty_message": "error.feedbacks.emptyMessage",
  "account.v1.lead_already_exists": "error.leads.alreadyExists",
  "account.v1.lead_invalid_input": "error.leads.invalidInput",
  "account.v1.lead_listing_not_live": "error.leads.listingNotLive",
  "account.v1.lead_not_found": "error.leads.notFound",
  "account.v1.lead_self_inquiry": "error.leads.selfInquiry",
  "account.v1.listing_already_exists": "error.listings.alreadyExists",
  "account.v1.listing_building_not_found": "error.listings.buildingNotFound",
  "account.v1.listing_cannot_publish_non_in_prog": "error.listings.cannotPublishNonInProg",
  "account.v1.listing_cannot_relist_incomplete": "error.listings.cannotRelistIncomplete",
  "account.v1.listing_cannot_relist_non_unlisted": "error.listings.cannotRelistNonUnlisted",
  "account.v1.listing_cannot_unlist_non_listed": "error.listings.cannotUnlistNonListed",
  "account.v1.listing_image_id_required": "error.listings.imageIdRequired",
  "account.v1.listing_image_not_found": "error.listings.imageNotFound",
  "account.v1.listing_invalid_input": "error.listings.invalidInput",
  "account.v1.listing_not_found": "error.listings.listingNotFound",
  "account.v1.listing_not_owner": "error.listings.notOwner",
  "account.v1.listing_wizard_incomplete": "error.listings.wizardIncomplete",
  "account.v1.saved_already_exists": "error.saved.alreadyExists",
  "account.v1.saved_invalid_input": "error.saved.invalidInput",
  "account.v1.saved_invalid_saveable_id": "error.saved.invalidSaveableId",
  "account.v1.saved_not_found": "error.saved.notFound",
  "account.v1.support_invalid_input": "error.support.invalidInput",
  "account.v1.support_not_found": "error.support.notFound",
  "auth.v1.already_linked": "error.auth.alreadyLinked",
  "auth.v1.check_failed": "error.generic",
  "auth.v1.code_required": "error.auth.codeRequired",
  "auth.v1.email_in_use": "error.auth.emailInUse",
  "auth.v1.email_not_verified": "error.auth.emailNotVerified",
  "auth.v1.google_sign_in_failed": "error.auth.googleSignInFailed",
  "auth.v1.invalid_code": "error.auth.invalidCode",
  "auth.v1.invalid_input": "error.auth.invalidInput",
  "auth.v1.invalid_phone": "error.auth.invalidPhone",
  "auth.v1.invalid_token": "error.auth.invalidToken",
  "auth.v1.last_provider": "error.auth.lastProvider",
  "auth.v1.link_failed": "error.generic",
  "auth.v1.not_linked": "error.auth.notLinked",
  "auth.v1.phone_in_use": "error.auth.phoneInUse",
  "auth.v1.phone_number_required": "error.auth.phoneNumberRequired",
  "auth.v1.rate_limited": "error.auth.rateLimited",
  "auth.v1.send_failed": "error.generic",
  "auth.v1.unlink_failed": "error.generic",
  "conversations.v1.content_empty": "error.conversations.contentEmpty",
  "conversations.v1.conversation_id_required": "error.conversations.conversationIdRequired",
  "conversations.v1.invalid_input": "error.conversations.invalidInput",
  "conversations.v1.message_blocked_external_contact": "error.conversations.messageBlockedExternalContact",
  "conversations.v1.not_participant": "error.conversations.notParticipant",
  "conversations.v1.unknown_read_cursor": "error.conversations.unknownReadCursor",
  "payments.v1.checkout_disabled": "error.payments.checkoutDisabled",
  "payments.v1.listing_already_paid": "error.payments.alreadyPaid",
  "storefront.v1.category_not_found": "error.storefront.categoryNotFound",
  "storefront.v1.district_not_found": "error.storefront.districtNotFound",
  "storefront.v1.estate_not_found": "error.storefront.estateNotFound",
  "storefront.v1.listing_not_found": "error.storefront.listingNotFound",
  "storefront.v1.partner_not_found": "error.storefront.partnerNotFound",
  "storefront.v1.post_not_found": "error.storefront.postNotFound",
};
